
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.125 8.1H2.669l6.684-6.548a.918.918 0 00.03-1.273.858.858 0 00-1.237-.03L.513 7.726C.183 8.067 0 8.52 0 9c0 .48.182.933.528 1.288l7.619 7.464a.858.858 0 001.237-.031.918.918 0 00-.03-1.273L2.642 9.9h17.483A.888.888 0 0021 9c0-.497-.392-.9-.875-.9z"}})])
          )
        }
      }
    